import React, { useState, useRef, Fragment } from 'react';
import { translate } from '../../Services/translation';
import { debounce } from 'lodash-es';
import { useSelector } from 'react-redux';

const OrderArticleSearch = ({ onSearch, add, deletePendingRow  }) => {

    const [searchText, setSearchText] = useState('');
    const searchInput = useRef(null);
    const { orderArticles, pendingReturn } = useSelector((state) => state.myPage.returns);

    const debouncedQuery = debounce((text) => {
        if (text.length > 2) {
            onSearch(text);
        }
    }, 200);

    return (
        <div className="returns__search-panel">
            <div className="returns__form " role="search">
                <div className="row">
                    <div className="small-12 columns">
                        <div className="return_search">
                            <h2>{translate('code.mypage.returnsearch.heading')}</h2>
                            <div className="returns__search-input-wrap">
                                <input className="returns__search-input-wrap-field"
                                    ref={searchInput}
                                    type="search"
                                    value={searchText}
                                    placeholder={translate('code.mypage.returnsearch.heading')}
                                    onChange={() => {
                                        setSearchText(searchInput.current.value);
                                        debouncedQuery(encodeURIComponent(searchInput.current.value));
                                    }}
                                />
                                <button
                                    className="returns__search-input-wrap-clear"
                                    onClick={() => setSearchText('')}>
                                    {translate('code.mypage.returnsearch.clear')}
                                </button>
                            </div>
                            {orderArticles && orderArticles.length > 0 && (
                                <table className="returns__autocomplete-articlesList">
                                    <thead>
                                        <tr>
                                            <th>&nbsp;</th>
                                            <th>{translate('code.mypage.returnsearch.designation')}</th>
                                            <th>{translate('code.mypage.returnsearch.articlenumber')}</th>
                                            <th className="text-right">{translate('code.mypage.returnsearch.addorderarticle')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orderArticles.map((orderArticle, index) => (
                                            <tr key={index}>
                                                <td></td>
                                                <td>{orderArticle.articleName}</td>
                                                <td>{orderArticle.articleNumber}</td>
                                                <td className="returns__button-container">{orderArticle.orders && orderArticle.orders.map((order, index2) => (
                                                    <Fragment key={index2}>
                                                        {order.pendingReturnRowSystemId ?
                                                            <div className={`returns__add-return-button${!order.orderDate ? ' returns__add-return-button--no-order' :''} active`}
                                                                onClick={() => deletePendingRow(pendingReturn.id, order.pendingReturnRowSystemId, index, index2)}>
                                                                <section title={translate('code.mypage.returnsearch.removefromreturn')}>
                                                                    <span>{order.orderNumber} {order.orderDate && (
                                                                        <Fragment>({order.quantity})</Fragment>
                                                                    )}
                                                                    </span><i>{order.orderDate}</i>
                                                                </section>
                                                            </div>
                                                            :
                                                            <div onClick={() => add(order.orderNumber, orderArticle.articleNumber, (pendingReturn ? pendingReturn.id : null), index, index2)}
                                                                className={`returns__add-return-button${!order.orderDate ? ' returns__add-return-button--no-order' :''}`}>
                                                                <section title={translate('code.mypage.returnsearch.returnfromordershort')}>                                                      
                                                                    <span className={order.orderDate ? 'returns__add-return-button--text' : ''}>
                                                                        <span>
                                                                            {order.orderNumber} {order.orderDate && (
                                                                                <Fragment>({order.quantity})</Fragment>
                                                                            )}  
                                                                        </span>
                                                                    </span>                                                                  
                                                                    <i>{order.orderDate}</i>
                                                                </section>
                                                            </div>
                                                        }
                                                    </Fragment>)
                                                )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderArticleSearch;